import React from 'react';

interface SvgProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  colour?: string;
  type: string;
  rotation?: string;
}

export const Svg: React.FC<SvgProps> = ({ 
  size, 
  colour, 
  type, 
  rotation, 
  ...otherProps 
}) => {
  return (
    <div className="mz-svg-wrapper" {...otherProps}>
      <i
        style={{ fontSize: size + 'rem' }}
        className={[
          'mz-svg',
          colour ? `mz-svg--${colour}` : '',
          type ? `mz-svg-${type}` : '',
          rotation ? `mz-svg--rotate${rotation}` : '',
        ].join(' ')}
      />
    </div>
  );
};

export default Svg;
